module.exports = __webpack_public_path__ + "static/img/Logo_Daiichi-sankyo@2x.a4cceea.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/Logo_Daiichi-sankyo@2x.png
// module id = PNU5
// module chunks = 1